import Vue from 'vue'
import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    shopPageList: [],
    shopProperty: {}
  },
  mutations: {
    setShopPageList (state, data) {
      if (!Array.isArray(data)) return

      const map = new Map(state.shopPageList.map(item => [item.pageId, item]))

      // 기존 + 신규 데이터를 pageId 기준으로 병합
      data.forEach(item => {
        map.set(item.pageId, { ...map.get(item.pageId), ...item })
      })

      state.shopPageList = Array.from(map.values())
    },
    setShopProperty (state, data) {
      if (!data) return
      const { pageId, key, value } = data
      if (!state.shopProperty[pageId]) {
        Vue.set(state.shopProperty, pageId, {})
      }
      Vue.set(state.shopProperty[pageId], [key], value)
    }
  },
  actions: {
    // 연동가능한 샵 코드 호출
    async getConnectShopCodes ({ state }, catCode) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-connect-shopCodes',
          id: store.state.authentication.requestId,
          body: {
            catCode: catCode
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 샵 생성하기
    async initShopServicePage ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'init-shop-service-page',
          id: store.state.authentication.requestId,
          body: data
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 샵 복제하기
    async copyShopPage ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'copy-shop-page',
          id: store.state.authentication.requestId,
          body: data
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 모든 샵 리스트 호출
    async getShopPageList ({ state, commit }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'get-order-page-list',
          category: 'system-shopping-service',
          id: store.state.authentication.requestId
        }, API.KEYHEADER)
        if (res?.data?.message?.pageList) {
          commit('setShopPageList', res.data.message.pageList)
        }
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 페이지 호출
    async getShopPage ({ state }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'get-order-page',
          id: store.state.authentication.requestId,
          pageId: pageId
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 페이지 업데이트 (마무리 해야함)
    async updateShopPage ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'update-order-page',
          id: store.state.authentication.requestId,
          pageId: data.pageId,
          catCode: data.catCode,
          pageName: data.pageName,
          isUseCallStaff: data.isUseCallStaff,
          excludeTax: data.excludeTax,
          settings: data.settings
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 페이지 삭제
    async deleteShopPage ({ state }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'delete-order-page',
          id: store.state.authentication.requestId,
          pageId: pageId
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 데이터 동기화
    async requestSyncPos ({ state }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'request-sync-pos',
          id: store.state.authentication.requestId,
          body: {
            pageId: pageId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 카테고리 호출
    async getShopCategory ({ state }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-category',
          id: store.state.authentication.requestId,
          body: {
            pageId: pageId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 카테고리 생성/수정
    async putShopCategory ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'put-shop-category',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            categories: data.categories
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 모든 샵 아이템 리스트 호출
    async getAllShopItems ({ state }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-all-shop-items',
          id: store.state.authentication.requestId,
          ...pageId && {
            body: {
              pageId: pageId
            }
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 아이템 리스트 호출
    async getShopItems ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-items',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            categoryId: data.categoryId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 아이템 순서 호출 (카테고리별)
    async setShopItemIndex ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'set-shop-item-index',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            categoryId: data.categoryId,
            shopItemIndex: data.shopItemIndex // shopItemIds
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 아이템 생성
    async createShopItem ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'create-shop-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            shopItemId: data.shopItemId,
            shopItemName: data.shopItemName,
            title: data.title,
            ...data.pId && {
              pId: data.pId
            },
            quantity: data.quantity,
            category: data.category,
            availableTime: data.availableTime,
            displayTime: data.displayTime,
            promotions: data.promotions,
            thumb: data.thumb,
            thumbOrigin: data.thumbOrigin,
            descList: data.descList,
            detailImage: data.detailImage,
            directOption: data.directOption,
            selectOptionByQuantity: data.selectOptionByQuantity,
            replaceOptionPrice: data.replaceOptionPrice,
            quantityByGuest: data.quantityByGuest,
            quantityByOrder: data.quantityByOrder,
            excludeGuestGroupIds: data.excludeGuestGroupIds,
            ignoreLimit: data.ignoreLimit,
            ...data.option && {
              option: data.option
            },
            ...data.priceInfo && {
              priceInfo: data.priceInfo
            },
            detailShopItemName: data.detailShopItemName,
            passFirstOption: data.passFirstOption,
            isCallItem: data.isCallItem,
            isSetItem: data.isSetItem
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 아이템 업데이트
    async updateShopItem ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'update-shop-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            isActive: data.isActive !== false,
            isCallItem: data.isCallItem === true,
            isSetItem: data.isSetItem === true,
            shopItemId: data.shopItemId,
            shopItemName: data.shopItemName,
            allowReplaceItemName: data.allowReplaceItemName === true,
            ...data.title && {
              title: data.title
            },
            ...data.pId && {
              pId: data.pId
            },
            quantity: data.quantity,
            category: data.category,
            availableTime: data.availableTime,
            displayTime: data.displayTime,
            promotions: data.promotions,
            status: data.status,
            thumb: data.thumb,
            thumbOrigin: data.thumbOrigin,
            descList: data.descList,
            detailImage: data.detailImage,
            directOption: data.directOption,
            selectOptionByQuantity: data.selectOptionByQuantity,
            replaceOptionPrice: data.replaceOptionPrice,
            quantityByGuest: data.quantityByGuest,
            quantityByOrder: data.quantityByOrder,
            excludeGuestGroupIds: data.excludeGuestGroupIds,
            ignoreLimit: data.ignoreLimit,
            ...data.option && {
              option: data.option
            },
            ...data.priceInfo && {
              priceInfo: data.priceInfo
            },
            detailShopItemName: data.detailShopItemName,
            passFirstOption: data.passFirstOption
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 아이템 호출
    async getShopItem ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            shopItemId: data.shopItemId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 아이템의 옵션 정보 호출
    async getShopItemOption ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-item-option',
          id: store.state.authentication.requestId,
          body: {
            id: data.optionId,
            shopItemId: data.shopItemId,
            viewAll: true
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 아이템 삭제 전 사용되고 있는 데이터가 있는지 체크
    async checkUseShopItem ({ state }, shopItemId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'check-use-shop-item',
          id: store.state.authentication.requestId,
          body: {
            shopItemId: shopItemId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 아이템 삭제
    async delShopItem ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'delete-shop-item',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            shopItemId: data.shopItemId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 인원 설정 호출
    async getShopGuestSettings ({ state }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-guest-settings',
          id: store.state.authentication.requestId,
          body: {
            pageId: pageId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 인원 설정 생성/수정
    async putShopGuestSettings ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'put-shop-guest-settings',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            active: data.active,
            title: data.title,
            settingItems: data.settingItems
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 주문제한 호출
    async getShopOrderLimit ({ state }, pageId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-order-limit',
          id: store.state.authentication.requestId,
          body: {
            pageId: pageId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 주문제한 생성/수정
    async putShopOrderLimit ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'put-shop-order-limit',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            setting: {
              orderableTime: data.orderableTime || 0,
              orderableMessage: data.orderableMessage || 0,
              waitingOrder: data.waitingOrder || 0,
              orderLimit: data.orderLimit || 0
            }
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 특정 카테고리 설정 호출
    async getShopCategorySettings ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-category-settings',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            categoryId: data.categoryId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 샵 특정 카테고리 설정 생성/수정
    async putShopCategorySettings ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'put-shop-category-settings',
          id: store.state.authentication.requestId,
          body: {
            pageId: data.pageId,
            categoryId: data.categoryId,
            limitItemCount: data.limitItemCount
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 스토어(라이브러리) 옵션 생성/수정
    async putShopStoreOption ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'put-shop-store-option',
          id: store.state.authentication.requestId,
          body: {
            id: data.id,
            name: data.name,
            title: data.title,
            type: data.type,
            isRequired: data.isRequired,
            optionItems: data.optionItems,
            ...data.typeOption && {
              typeOption: data.typeOption
            }
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 스토어(라이브러리) 옵션 호출
    async getShopStoreOptionList ({ state }, shopItemId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-store-option-list',
          id: store.state.authentication.requestId,
          ...shopItemId && {
            body: {
              shopItemId: shopItemId
            }
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 스토어(라이브러리) 옵션 삭제
    async delStoreOption ({ state }, optionId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'delete-store-option',
          id: store.state.authentication.requestId,
          body: {
            id: optionId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 스토어(라이브러리) 옵션 디테일 호출
    async getShopStoreOption ({ state }, optionId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-store-option',
          id: store.state.authentication.requestId,
          body: {
            id: optionId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 스토어(라이브러리) 옵션의 아이템 중 샵아이템으로 추가 가능한 리스트 호출
    async getAvailableShopOptItems ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-available-shop-opt-items',
          id: store.state.authentication.requestId
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 프리셋 생성/수정 (option, promotion, availableTime)
    async putShopPreset ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'put-shop-store-preset',
          id: store.state.authentication.requestId,
          body: {
            presetId: data.presetId,
            presetName: data.presetName,
            presetType: data.presetType,
            presetOptions: data.presetOptions
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 프리셋 타입별 리스트 호출 (option, promotion, availableTime)
    async getShopPresetList ({ state }, presetType) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-store-preset-list',
          id: store.state.authentication.requestId,
          body: {
            presetType: presetType
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 프리셋 아이템 호출
    async getShopPresetDetail ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-shop-store-preset',
          id: store.state.authentication.requestId,
          body: {
            presetType: data.presetType,
            presetId: data.presetId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 프리셋 아이템 삭제 전 사용되고 있는 데이터가 있는지 체크
    async checkUseStorePreset ({ state }, presetId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'check-use-store-preset',
          id: store.state.authentication.requestId,
          body: {
            presetId: presetId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // 특정 프리셋 아이템 삭제
    async delShopPreset ({ state }, presetId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'delete-store-preset',
          id: store.state.authentication.requestId,
          body: {
            presetId: presetId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // catCode별 인원그룹 호출 (shopPage별 저장했었으나 catCode별 저장으로 변경)
    async getGuestTypeItems ({ state }, catCode) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'get-guest-type-items',
          id: store.state.authentication.requestId,
          body: {
            catCode: catCode
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // catCode별 인원그룹 추가/수정
    async putGuestTypeItems ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'put-guest-type-item',
          id: store.state.authentication.requestId,
          body: {
            catCode: data.catCode,
            groupId: data.groupId,
            groupName: data.groupName
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
    // catCode별 인원그룹 삭제
    async delGuestTypeItems ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-order-api',
          func: 'shop-service-api',
          requestApi: 'delete-guest-type-item',
          id: store.state.authentication.requestId,
          body: {
            catCode: data.catCode,
            groupId: data.groupId
          }
        }, API.KEYHEADER)
        return res.data
      } catch (ex) {
        console.log(ex)
        return ex && ex.response && ex.response.data
      }
    },
  },
  getters: {
    getShopPageList: state => state.shopPageList,
    getShopResultData: () => (code) => {
      let result = true
      switch (code) {
        case 301:
          result = 'invalid_category' // 유효하지 카테고리로 설정할 수 없음
          break
        case 303:
          result = 'is_base_pos' // 포스연동 상품이라 특수 정보를 변경할 수 없음
          break
        case 304:
          result = 'include_preset' // 프리셋에 포함된 옵션임
          break
        case 305:
          result = 'exist_pId' // pId 중복
          break
        case 306:
          result = 'guest_group_used_shop' // 인원그룹이 이미 사용중이라 삭제할 수 없음
          break
        // 351~500까지는 공통에러
        case 351:
          result = 'invalid_format' // 형식에 맞지 않는 정보(invalid format)
          break
        case 401:
          result = 'inactivate' // 비활성화 또는 서비스 하지 않는 사이트
          break
        case 403:
          result = 'invalid_request' // 유효하지 않은 요청 데이터
          break
        case 405:
          result = 'invalid_site' // 사이트 정보가 없음
          break
        case 406:
          result = 'not_found_data' // 데이터가 없음
          break
        case 500:
          result = 'system_error' // 내부 오류
          break
      }
      return result
    },
    getShopProperty: state => (pageId) => {
      const shop = state.shopProperty[pageId]
      return shop
    }
  }
}
